import axios from "axios";
import { API, Endpoints } from "./Constants";
import JSZip from 'jszip';

export const getAuthString = () => {
  let token = localStorage.getItem('agentModuleToken');
  if (token == null) {
    token = "";
  }
  return token;
}

export const clearLocalStorageExceptOne = (keysToRetain) => {
  const keys = Object.keys(localStorage);

  // Loop through the keys and remove items that are not in keysToRetain
  keys.forEach((key) => {
    if (!keysToRetain.includes(key)) {
      localStorage.removeItem(key);
    }
  });
};

export const objToArray = (obj) => {
  let resultArray = [];

  for (let key in obj) {
    if (obj[key].length > 0 && obj[key] != '') {
      let a = {};
      a[key] = obj[key];
      resultArray.push(a);
    }
  }

  return resultArray;
}
const accessToken = localStorage.getItem("agentModuleToken");


export const downloadFlooringDocuments = async (type, appId, formType) => {
  try {
    const response = await axios.get(API.BaseUrl + Endpoints.downloadFlooringDocumnets + `${appId}` + '/' + formType, {
      responseType: 'arraybuffer', // Important for handling binary data
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    // Create a Blob from the Base64-encoded data
    const blob = new Blob([response.data], { type: 'application/zip' });
    // Create a URL for the Blob data
    const url = URL.createObjectURL(blob);
    // Create a download link
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = type + '_documents.zip';
    document.body.appendChild(a);
    // Trigger the download
    a.click();
    // Clean up the URL object to free resources
    URL.revokeObjectURL(url);
    // Remove the download link from the document
    document.body.removeChild(a);
  } catch (error) {
    console.error('Error downloading documents:', error);
  }
}

export const downloadFlooringDocumentsUnzip = async (type, appId, formType) => {
  try {
    const response = await axios.get(API.BaseUrl + Endpoints.downloadFlooringDocumnets + `${appId}` + '/' + formType, {
      responseType: 'arraybuffer', // Important for handling binary data
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
    // Create a Blob from the Base64-encoded data
    const blob = new Blob([response.data], { type: 'application/zip' });
    const zip = await JSZip.loadAsync(blob);

    // Iterate through the files in the zip and create download links for each file
    zip.forEach(async (relativePath, file) => {
      const fileBlob = await file.async('blob');
      const url = URL.createObjectURL(fileBlob);

      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = relativePath; // Use the file's original name
      document.body.appendChild(a);

      a.click();

      // Clean up the URL object and remove the download link
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  } catch (error) {
    console.error('Error downloading documents:', error);
  }
}


export const downloadDocuments = async (type, applicationID, guarantorID) => {
    
  try {
    const baseUrl = API.BaseUrl + Endpoints.downloadDocuments;
    let API_URL = `${baseUrl}${applicationID}/${type}`;

    if (guarantorID) {
      API_URL += `/${guarantorID}`;
    }
    const response = await axios.get(API_URL, {
      responseType: 'arraybuffer', // Important for handling binary data
    });
    // Create a Blob from the Base64-encoded data
    const blob = new Blob([response.data], { type: 'application/zip' });
    // Create a URL for the Blob data
    const url = URL.createObjectURL(blob);
    // Create a download link
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = type + '_documents.zip';
    document.body.appendChild(a);
    // Trigger the download
    a.click();
    // Clean up the URL object to free resources
    URL.revokeObjectURL(url);
    // Remove the download link from the document
    document.body.removeChild(a);
  } catch (error) {
    console.error('Error downloading documents:', error);
  }
}

export const downloadDocumentsUnzip = async (type, applicationID, guarantorID) => {
  try {
    const baseUrl = API.BaseUrl + Endpoints.downloadDocuments;
    let API_URL = `${baseUrl}${applicationID}/${type}`;

    if (guarantorID) {
      API_URL += `/${guarantorID}`;
    }
    const response = await axios.get(API_URL, {
      responseType: 'arraybuffer', // Important for handling binary data
    });
    // Create a Blob from the Base64-encoded data
    const blob = new Blob([response.data], { type: 'application/zip' });
    const zip = await JSZip.loadAsync(blob);

    // Iterate through the files in the zip and create download links for each file
    zip.forEach(async (relativePath, file) => {
      const fileBlob = await file.async('blob');
      const url = URL.createObjectURL(fileBlob);

      const a = document.createElement('a');
      a.style.display = 'none';
      a.href = url;
      a.download = relativePath; // Use the file's original name
      document.body.appendChild(a);

      a.click();

      // Clean up the URL object and remove the download link
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
    });
  } catch (error) {
    console.error('Error downloading documents:', error);
  }
}

export const downloadApplications = async () => {
  try {
    const response = await axios.get(API.BaseUrl + Endpoints.downloadAllApplications + localStorage.getItem('applicationId') + '/all', {
      responseType: 'arraybuffer', // Important for handling binary data
    });
    // Create a Blob from the Base64-encoded data
    const blob = new Blob([response.data], { type: 'application/zip' });
    // Create a URL for the Blob data
    const url = URL.createObjectURL(blob);
    // Create a download link
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = 'applications.zip';
    document.body.appendChild(a);
    // Trigger the download
    a.click();
    // Clean up the URL object to free resources
    URL.revokeObjectURL(url);
    // Remove the download link from the document
    document.body.removeChild(a);
  } catch (error) {
    console.error('Error downloading documents:', error);
  }
}

export const handleDownload = async (url) => {
  try {
    const response = await fetch(url);
    if (response.ok) {
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'summary.pdf';
      link.click();
    }
  } catch (error) {
  }
};

export const handleSummaryDownload = async (url, data) => {
  try {
    const response = await fetch(`${url}`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('agentModuleToken')
          }`,
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = 'summary.pdf';
      link.click();
    }
  } catch (error) {
  }
};

